<template>
  <div>
    <div v-if="isVisible" class="obj_push push_promo-selected">
      <span class="t_titre">{{ title }}</span>
      <a v-if="!removeFilter" class="btn_close" @click="closePromotionBanner()">
        <span>X</span>
      </a>
      <div v-if="imageUrl" class="ctn_promo">
        <img :src="imageUrl" :alt="title" />
      </div>
      <div v-else class="ctn_promo ctn_promo_banner">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import Event from './promotion-banner-event';

export default {
  name: 'rfp-storelocator-promotion-banner',
  data() {
    return {
      isVisible: false,
      description: '',
      title: '',
      removeFilter: false,
      imageUrl: '',
    };
  },
  created() {
    eventBus.on(Event.List, (x) => {
      this.isVisible = true;
      this.description = x.Description;
      this.title = x.Title;
      this.imageUrl = x.ImageUrl;
      eventBus.emit(Event.BannerEnabled, true);
    });
    eventBus.on(Event.ListQueryParams, () => {
      this.description = '';
      this.title = '';
      this.imageUrl = '';
      this.removeFilter = true;
    });
    eventBus.on(Event.BannerClosed, () => {
      this.description = '';
      this.title = '';
      this.imageUrl = '';
      this.isVisible = false;
      eventBus.emit(Event.BannerEnabled, false);
    });
  },
  methods: {
    closePromotionBanner() {
      eventBus.emit(Event.RefreshMapOptions);
      this.description = '';
      this.title = '';
      this.imageUrl = '';
      this.isVisible = false;
      eventBus.emit(Event.BannerEnabled, false);
      eventBus.emit(Event.BannerClosed);
      eventBus.emit(Event.BannerFilter, '');
    },
  },
};
</script>
